module.exports = __webpack_public_path__ + "img/icons.71bb3f7e.png";